

























































































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import {
  CatalogSession,
  SessionEnrollmentStatus,
  SessionDiscount,
  DiscountUnitsEnum
} from '@/Model/sessions/catalogTypes'
import APP_UTILITIES from '@/utilities/commonFunctions'
import discountStore from '@/store/modules/discounts'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import bannerSwallowtail from '@/components/icons/banner-swallowtail.vue'
import { VerifiedSiteLocation } from '@/Model/sessions/types'
import {
  hasCapacityFull,
  hasScholarCapacityFull,
  hasWaitListCapacityFull
} from '@/utilities/session'
import SessionDiscountBadge from '@/components/familyPortal/sessionCard/SessionDiscountBadge.vue'

@Component({
  components: {
    bannerSwallowtail,
    SessionDiscountBadge
  }
})
export default class SessionCard extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession
  @PropSync('isAutomaticDiscountEnabled', { type: Boolean }) isAutomaticDiscountEnabledSync!: boolean

  readonly screenText = new ScreenText()

  get isEarlyDiscountApplied(): boolean {
    return this.session.earlyRegistrationDiscount.isApplied && this.session.price > 0
  }

  get isMultiparticipantDiscountApplied(): boolean {
    return this.session.multiParticipantDiscount.isApplied && this.session.price > 0
  }

  get earlyDiscountName(): string {
    return discountStore.earlyDiscountData ? discountStore.earlyDiscountData.name : ''
  }

  get multiDiscountName(): string {
    return discountStore.multiParticipantDiscountData
      ? discountStore.multiParticipantDiscountData.name
      : ''
  }

  get earlyDiscountDescription(): string {
    return discountStore.earlyDiscountData ? discountStore.earlyDiscountData.description : ''
  }

  get multiParticipantDiscountDescription(): string {
    return discountStore.multiParticipantDiscountData
      ? discountStore.multiParticipantDiscountData.description
      : ''
  }

  get earlyDiscountAmount(): string {
    // we check if we are under a percentage or fixed usage to properly display the discount label
    const amount =
      this.session.earlyRegistrationDiscount.unit === DiscountUnitsEnum.FixedAmountDescription
        ? this.session.earlyRegistrationDiscount.netItemDiscount
        : this.session.earlyRegistrationDiscount.value
    const message = APP_UTILITIES.addSymbol(
      amount,
      this.session.earlyRegistrationDiscount.unit === DiscountUnitsEnum.FixedAmountDescription
    )
    return message
  }

  get multiParticipantDiscountAmount(): string {
    // we check if we are under a percentage or fixed usage to properly display the discount label
    const amount =
      this.session.multiParticipantDiscount.unit === DiscountUnitsEnum.FixedAmountDescription
        ? this.session.multiParticipantDiscount.netItemDiscount
        : this.session.multiParticipantDiscount.value
    return APP_UTILITIES.addSymbol(
      amount,
      this.session.multiParticipantDiscount.unit === DiscountUnitsEnum.FixedAmountDescription
    )
  }

  public sessionApplicableDiscounts: {
    earlyRegistrationDiscount: SessionDiscount | null
    multiParticipantDiscount: SessionDiscount | null
  } = {
    earlyRegistrationDiscount: null,
    multiParticipantDiscount: null
  }

  created() {
    this.sessionApplicableDiscounts.earlyRegistrationDiscount = this.session
      .earlyRegistrationDiscount.isApplied
      ? this.session.earlyRegistrationDiscount
      : null

    this.sessionApplicableDiscounts.multiParticipantDiscount = this.session.multiParticipantDiscount
      .isApplied
      ? this.session.multiParticipantDiscount
      : null
  }

  get hasLocation(): boolean {
    return this.session.siteLocationId !== undefined && this.session.siteLocationId !== null
  }

  get startDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.startDateTime)
  }

  get endDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.endDateTime)
  }

  get days(): string {
    if (this.session.selectedDays) {
      const abbrMap = new Map(
        APP_UTILITIES.getDaysAbbreviations(false).map(e => [e.day, e.abbreviation])
      )
      return this.session.selectedDays.map(e => abbrMap.get(e)).join(', ')
    }
    return ''
  }

  get startTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.startDateTime, true)
  }

  get endTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.endDateTime, true)
  }

  get site(): VerifiedSiteLocation | undefined {
    return this.session.siteLocation
  }

  get isSessionClosed(): boolean {
    return (
      this.session.sessionEnrollmentStatus == SessionEnrollmentStatus.Ended ||
      hasCapacityFull(this.session)
    )
  }

  get isWaitlistOpen(): boolean {
    return hasScholarCapacityFull(this.session) && !hasWaitListCapacityFull(this.session)
  }

  get formattedAgeRestriction(): string {
    // XXX this will need to be localized in future work
    if (this.session.ageFrom) {
      if (this.session.ageTo) {
        if (this.session.ageFrom == this.session.ageTo) {
          return `${this.ageText} ${this.session.ageFrom}`
        } else {
          return `${this.agesText} ${this.session.ageFrom}-${this.session.ageTo}`
        }
      } else {
        return `${this.agesText} ${this.session.ageFrom} ${this.andAboveText}`
      }
    } else if (this.session.ageTo) {
      return `Ages ${this.session.ageTo} ${this.andBelowText}`
    } else {
      return ''
    }
  }

  get waitlistText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_WAITLIST')
  }

  get addToCartText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_ADD_TO_CART')
  }

  get closedText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_CLOSED')
  }

  get ageText(): string {
    return this.screenText.getScreenText('CATALOG_AGE')
  }

  get agesText(): string {
    return this.screenText.getScreenText('CATALOG_AGES')
  }

  get andBelowText(): string {
    return this.screenText.getScreenText('CATALOG_AND_BELOW')
  }

  get andAboveText(): string {
    return this.screenText.getScreenText('CATALOG_AND_ABOVE')
  }
}
